import React from 'react'
import {
  Box,
  IconButtonProps,
  IconButton,
  CircularProgress,
  Typography
} from '@mui/material'

import AddCircleIcon from '@mui/icons-material/AddCircle'

interface SaveIconProps extends IconButtonProps {
  companionText?: string
  fontSize: 'small' | 'medium'
  isLoading?: boolean
}

export const AddIconButton: React.FC<SaveIconProps> = ({
  companionText,
  fontSize,
  isLoading = false,
  ...iconButtonProps
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {companionText && (
        <Typography variant='body1'>{companionText}</Typography>
      )}
      <IconButton aria-label='delete' disabled={isLoading} {...iconButtonProps}>
        {isLoading ? (
          <CircularProgress size={fontSize} />
        ) : (
          <AddCircleIcon fontSize={fontSize} />
        )}
      </IconButton>
    </Box>
  )
}
